import { render, staticRenderFns } from "./saveChangesDialog.vue?vue&type=template&id=4b1d38c3&scoped=true"
import script from "./saveChangesDialog.vue?vue&type=script&lang=js"
export * from "./saveChangesDialog.vue?vue&type=script&lang=js"
import style0 from "./saveChangesDialog.vue?vue&type=style&index=0&id=4b1d38c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1d38c3",
  null
  
)

export default component.exports